import { ButtonSize, TertiaryButton } from '@ardoq/button';
import { Icon, IconName } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { ToolbarDivider } from '@ardoq/page-layout';
import { Text } from '@ardoq/typography';
import { ViewpointToolBarButton } from './toViewpointToolBarProps';
import { t, type I18nLocale } from '@ardoq/i18n';
import { ShowExcludedButton } from './ShowExcludedButton';
import { tourAnchorIds } from '@ardoq/product-tours';

type DisabledToolbarProps = {
  excludedComponentCount: number;
  i18nLocale: I18nLocale;
  isDiscover: boolean;
  datasetsButton: ViewpointToolBarButton;
  viewpointsButton: ViewpointToolBarButton;
  openInInventoryButton?: ViewpointToolBarButton;
  contextDropdownDisabledText: string;
};

const DisabledToolbar = ({
  excludedComponentCount,
  i18nLocale,
  isDiscover,
  datasetsButton,
  viewpointsButton,
  openInInventoryButton,
  contextDropdownDisabledText,
}: DisabledToolbarProps) => (
  <FlexBox
    gap="medium"
    align="center"
    data-tour-id={tourAnchorIds.canvasViewpointToolbar}
  >
    <FlexBox gap="xsmall" align="center">
      <Text color="textSubtle" variant="caption">
        {t(i18nLocale, 'canvas:contextToolbarContextLabel', 'Context')}
      </Text>
      <TertiaryButton
        buttonSize={ButtonSize.SMALL}
        isDisabled
        data-tooltip-text={contextDropdownDisabledText}
      >
        &mdash;
        <Icon iconName={IconName.CHEVRON_DOWN} />
      </TertiaryButton>
    </FlexBox>
    <FlexBox gap="xsmall" align="center">
      <Text color="textSubtle" variant="caption">
        {t(i18nLocale, 'canvas:contextToolbarViewpointColon', 'Viewpoint:')}
      </Text>
      <TertiaryButton
        buttonSize={ButtonSize.SMALL}
        isDisabled
        data-tooltip-text={viewpointsButton.disabledPopoverText}
      >
        <Icon iconName={viewpointsButton.iconName} />
        {t(i18nLocale, 'canvas:contextToolbarViewpointLabel', 'Viewpoint')}
      </TertiaryButton>
    </FlexBox>
    {!isDiscover && (
      <>
        <ToolbarDivider />
        <TertiaryButton
          onClick={datasetsButton.onClick}
          isActive={datasetsButton.isActive}
          buttonSize={datasetsButton.buttonSize}
          isDisabled={datasetsButton.isDisabled}
        >
          <Icon iconName={datasetsButton.iconName} />
          {datasetsButton.text}
        </TertiaryButton>
      </>
    )}
    {openInInventoryButton && (
      <>
        <ToolbarDivider />
        <TertiaryButton
          onClick={openInInventoryButton.onClick}
          isActive={openInInventoryButton.isActive}
          buttonSize={openInInventoryButton.buttonSize}
          isDisabled={openInInventoryButton.isDisabled}
        >
          <Icon iconName={openInInventoryButton.iconName} />
          {openInInventoryButton.text}
        </TertiaryButton>
      </>
    )}
    <ShowExcludedButton
      excludedComponentCount={excludedComponentCount}
      isDiscover={isDiscover}
      i18nLocale={i18nLocale}
    />
  </FlexBox>
);

export { DisabledToolbar };
